import IDS from "./ids";

const LABELS = {
    INSURANCE_SUM: 'Общая стоимость груза (руб.)',
    FRANCHISE: 'Безусловная франшиза',
    CARGO_TYPE: 'Тип груза',
    CARGO_PACKAGING: 'Вид упаковки груза',
    CARGO_LOADING_TYPE: 'Габаритность груза',
    DISTANCE_AREA: 'Регион',
    DISTANCE_COUNT: 'Длина маршрута',
    DISTANCE_FROM: 'Город отправления',
    DISTANCE_TO: 'Город назначения',
    TRANSPORT_GUARD: 'Сопровождение груза',
    TRANSPORT_SHIPPING: 'Способ перевозки',
    TRANSPORT_TYPE: 'Используемые виды транспорта',
    TRANSPORT_STORAGE: 'Временное хранение груза',
    TRANSPORT_LOADING_COUNT: 'Погрузо-разгрузочные работы',
    TRANSPORT_LONG_DELIVERY: 'Автомобильная часть перевозки',
    CONTACT_PHONE: 'Телефон',
    CONTACT_NAME: 'Ваше Имя',
    CONTACT_NAME_INSURER: 'Контактное лицо',
    CONTACT_COMPANY: 'Название Вашей Организации',
    CONTACT_COMPANY_INSURER: 'Название Организации',
    CALCULATION_ID: 'Идентификатор текущего расчёта',
}

export default LABELS
